import projection from './projection';

export default {
  namespaced: true,
  modules: {
    projection,
  },
};
